import React from 'react';

const ValidationSummaryCard = ({ validationData, lastValidatedAt, onResolve }) => {
  const valid = Boolean(validationData?.valid);
  const issues = validationData?.issues?.length || 0;
  const warnings = validationData?.warnings?.length || 0;
  const sessionsWithIssues = validationData?.seat_capacity_balance?.sessions_with_issues || 0;

  return (
    <div className="rounded-lg bg-white p-4 shadow sm:p-6">
      <div className="flex items-center justify-between">
        <div>
          <div className={`text-sm font-medium ${valid ? 'text-green-700' : 'text-red-700'}`}>
            {valid ? 'All checks passed' : 'Issues detected'}
          </div>
          <div className="mt-1 text-xs text-gray-600">
            {issues} issue(s), {warnings} warning(s)
            {typeof lastValidatedAt === 'number' && (
              <span className="ml-2 text-gray-400">
                Last validated {new Date(lastValidatedAt).toLocaleTimeString()}
              </span>
            )}
          </div>
        </div>
        <button
          onClick={onResolve}
          className="rounded bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700"
        >
          Resolve {sessionsWithIssues > 0 ? `${sessionsWithIssues} session` : ''} issues
        </button>
      </div>
    </div>
  );
};

export default ValidationSummaryCard;
